import providerService from '../../../services/provider/ProviderService';
import locationService from '../../../services/location/LocationService';
import branchService from '../../../services/branch/BranchService';
import timeZoneService from '../../../services/scheduleRange/ScheduleRange';
import ShippinFeeService from '../../../services/shippinFee/ShippinFee.js';
import ShippinFeeList from './ShippinFeeList.vue'
import i18n from "../../../i18n/index";
import { Money } from 'v-money'

export default {
    components: {
        ShippinFeeList,
        Money
    },
    data() {
        return {
            rules: { required: value => !!value || i18n.t('field-required') },
            shippingFeeRules: [
                value => !!value || i18n.t('field-required'),
                value => parseFloat(('' + value).split(',').join('')) > -1 || i18n.t('fee-value-negative')
            ],
            hideList: false,
            shippingFee: {
                id: null,
                provider: '',
                branch: '',
                branchCity: '',
                scheduleRange: '',
                shippingFee: 0,
                active: ''
            },
            providers: [],
            branches: [],
            branchCities: [],
            scheduleRanges: [],
            editProccess: false,
            money: {
                decimal: '.',
                thousands: ',',
                precision: 0,
                masked: true
            },
            loadingSaveButton: false,
            chkShippingFee: false,
        };
    },
    mounted() {
        this.getProviders();
        this.getScheduleRanges();
    },
    methods: {
        async showDetail(item) {
            this.shippingFee.provider = item.idBranch.idProvider.id
            this.shippingFee.branch = item.idBranch.id
            this.shippingFee.branchCity = item.idBranchCity.id
            this.shippingFee.scheduleRange = item.idScheduleRange.id
            this.shippingFee.id = item.id
            this.shippingFee.shippingFee = parseFloat(item.shippingFee)
            this.chkShippingFee = item.active;
            this.hideList = true
            this.editProccess = true

            await this.getBranchCities()
            await this.getBranches()
        },
        async getProviders() {
            return await providerService.getProviders().then(response => {
                this.providers = response.data;
            });
        },
        async getScheduleRanges() {
            return await timeZoneService.getScheduleRanges().then(response => {
                this.scheduleRanges = response.data;
                this.scheduleRanges.forEach(sr => sr.range = sr.start + ' - ' + sr.end);
            });
        },
        async getBranches() {
            return await locationService.getBranchesByProvider(this.shippingFee.provider).then(response => {
                this.branches = response.data;
            });
        },
        async getBranchCities() {
            return await locationService.getBranchCitiesByBranch(this.shippingFee.branch).then(response => {
                this.branchCities = response.data;
                this.branchCities.forEach(bc => bc.name = bc.idCity.idState.name + ', ' + bc.idCity.name);
            });
        },
        save() {
            this.shippingFee.shippingFee = parseFloat(('' + this.shippingFee.shippingFee).split(',').join(''));

            if (!this.$refs.branchForm.validate()) {
                this.loadingSaveButton = true;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.error-required-fields")
                });
                return;
            }
            this.shippingFee.active = this.chkShippingFee;
            // this.shippingFee.active == true ? true : false;

            branchService.createShippingFee(this.shippingFee).then(resp => {
                this.loadingSaveButton = false;
                this.$refs.ShippinFeeList.getShippinFee()
                this.$notify({
                    group: "app",
                    type: "success",
                    text: i18n.t('record-successfully-created')
                });
                this.editProccess = false
                this.close();
            }).catch(error => {
                this.loadingSaveButton = false;
                if (error.code == "ALREADY_EXIST") {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: i18n.t('record-equal-already-exists')
                    });
                }
            });
        },
        close() {
            this.shippingFee = {
                id: null,
                provider: '',
                branch: '',
                branchCity: '',
                scheduleRange: '',
                shippingFee: 0
            };
            this.branches = [];
            this.branchCities = [];
            this.hideList = false;
            this.editProccess = false
        },
        deleteFee() {
            this.loadingSaveButton = true;
            let data = { id: this.shippingFee.id };
            ShippinFeeService.deleteShippinFee(data).then(result => {
                if (result.status == 200) {
                    this.loadingSaveButton = false;
                    this.$refs.ShippinFeeList.getShippinFee()
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Flete Eliminado'
                    });
                    this.close();
                }
            }).catch(error => {
                this.loadingSaveButton = false;
                if (error == 'The scheduleRange has associated transactions') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: i18n.t('FEE_ASSOCIED')
                    });
                }

            });
        },
        updateProvider() {
            let providerId = this.Provider.id;
            this.Provider.active = this.chkProvider;
            let data = {
                name: this.Provider.name,
                fiscalNumber: this.Provider.fiscalNumber,
                active: this.Provider.active == true ? 1 : 0,
            };
            this.loadingSaveButton = true;
            this.showIcon = true;

            providerService.updateProviders(providerId, data).then(result => {
                this.loadingSaveButton = false;
                if (result.status == 200) {
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "Motivo pendiente Actualizado"
                    });
                    this.$refs.ProviderList.searchProviders();
                    this.closeProvider();
                }
            }).catch(error => {
                this.loadingSaveButton = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error) {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "el proveerdor tiene transacciones"
                        })
                    }
                }
                this.$refs.ProviderList.searchProviders();
                this.closeProvider();
            });
        }
    }
}